export type YayLogoVariant = "purple" | "white" | "black";

const LOGO_SRC: Record<YayLogoVariant, string> = {
  purple: "/brand/yay-purple.svg",
  white: "/brand/yay-white.svg",
  black: "/brand/yay-black.svg",
};

interface YayLogoProps {
  variant?: YayLogoVariant;
  className?: string;
  alt?: string;
}

export function YayLogo({
  variant = "purple",
  className,
  alt = "Yay",
}: YayLogoProps) {
  return (
    <img
      src={LOGO_SRC[variant]}
      alt={alt}
      className={className}
      draggable={false}
    />
  );
}
